import {useTranslation} from 'react-i18next'
import {FichaDatos, type BloqueFicha} from '@/components/ui/ficha-datos'
import type {Ficha} from '@/hooks/empresa/identidad/use-ficha'
import {formatDateOnly} from '@/lib/risk'

const VACIO = '—'

export function FichaFacts({ficha}: {ficha: Ficha}) {
  const {t} = useTranslation()
  const opcion = (prefijo: string, valor: string | null | undefined) => (valor ? t(`${prefijo}.${valor}`) : VACIO)
  // Claves de rótulo literales: el gate `i18n-keys` solo ve esas y una armada por plantilla llega en crudo.
  const bloques: BloqueFicha[] = [
    {
      clave: 'cargo',
      // `clave` y `testId` siguen en «cargo»: son el contrato de los selectores, no el rótulo.
      titulo: t('ficha.bloques.puesto'),
      testId: 'ficha-bloque-cargo',
      filas: [
        {clave: 'cargo', etiqueta: t('ficha.cargo'), valor: ficha.cargo ?? VACIO},
        {
          clave: 'cargo_descripcion',
          etiqueta: t('ficha.cargoDescripcionRotulo'),
          valor: ficha.cargo_descripcion ?? VACIO,
        },
        {clave: 'area', etiqueta: t('ficha.area'), valor: ficha.area ?? VACIO},
        {clave: 'sede', etiqueta: t('ficha.sede'), valor: ficha.sede ?? VACIO},
        {
          clave: 'fecha_ingreso',
          etiqueta: t('ficha.fechaIngreso'),
          valor: ficha.fecha_ingreso ? formatDateOnly(ficha.fecha_ingreso) : VACIO,
        },
        {
          clave: 'tipo_vinculacion',
          etiqueta: t('ficha.tipoVinculacion'),
          valor: opcion('employees.contractType', ficha.tipo_vinculacion),
        },
        {
          clave: 'jornada_turno',
          etiqueta: t('ficha.jornadaTurno'),
          valor: opcion('ficha.jornadaOptions', ficha.jornada_turno),
        },
        {
          clave: 'antiguedad_meses',
          etiqueta: t('ficha.antiguedadMeses'),
          valor:
            ficha.antiguedad_meses != null ? t('ficha.antiguedadMesesValue', {count: ficha.antiguedad_meses}) : VACIO,
        },
      ],
    },
    {
      clave: 'persona',
      titulo: t('ficha.bloques.persona'),
      testId: 'ficha-bloque-persona',
      filas: [
        {
          clave: 'nivel_educativo',
          etiqueta: t('ficha.nivelEducativo'),
          valor: opcion('ficha.nivelEducativoOptions', ficha.nivel_educativo),
        },
        {clave: 'genero', etiqueta: t('ficha.genero'), valor: opcion('ficha.generoOptions', ficha.genero)},
        {
          clave: 'fecha_nacimiento',
          etiqueta: t('ficha.fechaNacimiento'),
          valor: ficha.fecha_nacimiento ? formatDateOnly(ficha.fecha_nacimiento) : VACIO,
        },
      ],
    },
    {
      clave: 'afiliaciones',
      titulo: t('ficha.bloques.afiliaciones'),
      testId: 'ficha-bloque-afiliaciones',
      filas: [
        {clave: 'eps', etiqueta: t('ficha.eps'), valor: ficha.eps ?? VACIO},
        {clave: 'afp', etiqueta: t('ficha.afp'), valor: ficha.afp ?? VACIO},
        // Al resto no le aplica (lo cubre la póliza de la empresa): una «—» diría que falta.
        ...(ficha.tipo_vinculacion === 'prestacion_servicios'
          ? [{clave: 'arl', etiqueta: t('ficha.arl'), valor: ficha.arl ?? VACIO}]
          : []),
      ],
    },
  ]

  return <FichaDatos bloques={bloques} />
}
